var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 54,
    viewBox: "0 0 50 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 53.25H25C23.9646 53.25 23.125 52.4104 23.125 51.375V2.625C23.125 1.58962 23.9646 0.75 25 0.75H47.5C48.5354 0.75 49.375 1.58962 49.375 2.625V51.375C49.375 52.4104 48.5354 53.25 47.5 53.25ZM26.875 49.5H45.625V4.5H26.875V49.5Z",
    fill: "#2AA7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53.25H32.5C31.4646 53.25 30.625 52.4104 30.625 51.375V40.125C30.625 39.0896 31.4646 38.25 32.5 38.25H40C41.0354 38.25 41.875 39.0896 41.875 40.125V51.375C41.875 52.4104 41.0354 53.25 40 53.25ZM34.375 49.5H38.125V42H34.375V49.5Z",
    fill: "#2AA7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 53.25H2.5C1.46462 53.25 0.625 52.4104 0.625 51.375V21.375C0.625 20.3396 1.46462 19.5 2.5 19.5H25C26.0354 19.5 26.875 20.3396 26.875 21.375V51.375C26.875 52.4104 26.0354 53.25 25 53.25ZM4.375 49.5H23.125V23.25H4.375V49.5Z",
    fill: "#2AA7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12H38.125V10.125C38.125 9.08962 37.2854 8.25 36.25 8.25C35.2146 8.25 34.375 9.08962 34.375 10.125V12H32.5C31.4646 12 30.625 12.8396 30.625 13.875C30.625 14.9104 31.4646 15.75 32.5 15.75H34.375V17.625C34.375 18.6604 35.2146 19.5 36.25 19.5C37.2854 19.5 38.125 18.6604 38.125 17.625V15.75H40C41.0354 15.75 41.875 14.9104 41.875 13.875C41.875 12.8396 41.0354 12 40 12Z",
    fill: "#2AA7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 34.5C8.96462 34.5 8.125 33.6604 8.125 32.625V28.875C8.125 27.8396 8.96462 27 10 27C11.0354 27 11.875 27.8396 11.875 28.875V32.625C11.875 33.6604 11.0354 34.5 10 34.5Z",
    fill: "#2AA7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 45.75C8.96462 45.75 8.125 44.9104 8.125 43.875V40.125C8.125 39.0896 8.96462 38.25 10 38.25C11.0354 38.25 11.875 39.0896 11.875 40.125V43.875C11.875 44.9104 11.0354 45.75 10 45.75Z",
    fill: "#2AA7FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 34.5C16.4646 34.5 15.625 33.6604 15.625 32.625V28.875C15.625 27.8396 16.4646 27 17.5 27C18.5354 27 19.375 27.8396 19.375 28.875V32.625C19.375 33.6604 18.5354 34.5 17.5 34.5Z",
    fill: "#2AA7FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 45.75C16.4646 45.75 15.625 44.9104 15.625 43.875V40.125C15.625 39.0896 16.4646 38.25 17.5 38.25C18.5354 38.25 19.375 39.0896 19.375 40.125V43.875C19.375 44.9104 18.5354 45.75 17.5 45.75Z",
    fill: "#2AA7FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34.5H32.5C31.4646 34.5 30.625 33.6604 30.625 32.625C30.625 31.5896 31.4646 30.75 32.5 30.75H40C41.0354 30.75 41.875 31.5896 41.875 32.625C41.875 33.6604 41.0354 34.5 40 34.5Z",
    fill: "#2AA7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.7270012001c36b83348a7f440bd46f68.svg";
export { ForwardRef as ReactComponent };